import React from "react";
import FieldProperties from "../FieldProperties";
import { FORM_ELEMENT_TYPES } from "../FormsConstant";
import ShowIfSection from "../ShowIfSection";
import FormAdminChipProperties from "./FormAdminChipProperties";
import FormDimensionReadOnly from "./FormDimensionReadOnly";
import RowConfiguration from "./RowConfiguration";

/**
 * Properties sidebar body when a canvas element is selected (not workflow variable / subsection).
 * @param {Object} props
 * @param {Object} [props.selectedElement]
 * @param {function(string|number, Object): void} props.onFieldPropertiesChange
 * @param {Array} [props.usedWorkflowVariableIds]
 * @author Abhishek Dhillon
 * @component FormPropertiesWrapper
 */
const FormElementPropertiesPanel = ({ selectedElement, onFieldPropertiesChange, usedWorkflowVariableIds, handleShowIfChange }) => {
  const type = selectedElement?.type;
  const isUserChip = type === FORM_ELEMENT_TYPES.USER_CHIP || Boolean(selectedElement?.properties?.isUserVariable);
  const showFieldProperties = type === FORM_ELEMENT_TYPES.TEXT_LABEL || type === FORM_ELEMENT_TYPES.TABLE;
  const showRowConfiguration = type === FORM_ELEMENT_TYPES.ROW_CONTAINER;

  return (
    <>
      {selectedElement?.properties?.isFormDimensionDisplay && <FormDimensionReadOnly element={selectedElement} onChange={onFieldPropertiesChange} />}
      {showFieldProperties && (
        <FieldProperties element={selectedElement} onChange={onFieldPropertiesChange} usedWorkflowVariableIds={usedWorkflowVariableIds} />
      )}
      {showRowConfiguration && <RowConfiguration element={selectedElement} onChange={onFieldPropertiesChange} />}
      {isUserChip && <FormAdminChipProperties selectedElement={selectedElement} onFieldPropertiesChange={onFieldPropertiesChange} />}
      {(showFieldProperties || showRowConfiguration || isUserChip || selectedElement) && (
        <ShowIfSection // Show If Section
          selectedElement={selectedElement}
          handleShowIfChange={handleShowIfChange}
        />
      )}
    </>
  );
};

export default FormElementPropertiesPanel;
